var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGwTl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 152,
    viewBox: "0 0 144 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_2862)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -16,
    r: 132,
    fill: "#C74132",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -16,
    r: 108,
    fill: "#C74132",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_2862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 152,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGwTl);
export default __webpack_public_path__ + "static/media/gw-tl.15d846060ce185ce5732693b63295e41.svg";
export { ForwardRef as ReactComponent };